import type { IconNames } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';

import QueueFromPayload from 'components/powerFlowShared/components/queueFromPayload';
import {
  FlowNodeTypes,
  OptionT,
} from 'components/powerFlowShared/components/types';
import {
  FlowNode,
  flowNodeColor,
  NodeT,
  NodeTypeComponent,
} from 'fable/flowEditor';

import ActionNode from '../../containers/modals/contactform';
import { PowerChatFlowExtraDataT } from '../PowerChatFlow';

export type FlowChatNodeContactFormPayloadT = {
  queue: OptionT;
  fromEmail?: string;
};

export type FlowChatNodeContactFormTypeT = FlowNodeTypes.CONTACT_FORM;
export type FlowChatNodeContactFormT = NodeT<
  FlowChatNodeContactFormTypeT,
  FlowChatNodeContactFormPayloadT
>;

export class ContactFormNode extends NodeTypeComponent<
  FlowChatNodeContactFormT,
  PowerChatFlowExtraDataT
>() {
  static icon: IconNames = 'chat-widget';
  static label = 'Contact Form';
  static color = flowNodeColor.green;
  static ActionModal = ActionNode;
  static actionTrigger = { type: FlowNodeTypes.CONTACT_FORM };
  static updateConnection = (
    node: FlowChatNodeContactFormT,
  ): FlowChatNodeContactFormT => node;

  @boundMethod
  triggerEdit(): void {
    const { onEdit, node } = this.props;
    onEdit(node, node.nodeType);
  }

  render() {
    return (
      <FlowNode
        color={ContactFormNode.color}
        icon={ContactFormNode.icon}
        label={ContactFormNode.label}
        text={<QueueFromPayload node={this.props.node} />}
        onEdit={this.triggerEdit}
      />
    );
  }
}
